<ng-container>
  <div class="toolbar">
    <div class="left"></div>
    <div class="spacer"></div>
    <div class="right">
      <button
        mat-stroked-button
        (click)="clearFilter()"
        matTooltip="{{ 'itemFilter.clearAll' | translate }}"
        *ngIf="(responsiveService.isHandset$ | async) === false"
      >
        <img class="custom-icon" src="assets/images/custom-icon/clear-filter.png" />
      </button>

      <app-item-selector
        [items]="availableColumnItems"
        [translate]="true"
        (changed)="availableColumnChanged($event)"
        matTooltip="{{ 'page.patientlist.columnsSelect' | translate }}"
      >
      </app-item-selector>
    </div>
  </div>
  <app-filters-display [filters]="this.filters" [parent]="'patientList'" (removeFilter)="applyFilter($event)"> </app-filters-display>
  <mat-card class="mat-elevation-z0 pt-0">
    <mat-table class="mat-elevation-z1" [dataSource]="dataSource" matSort matSortActive="dateRequest" matSortDirection="asc">
      <!-- Name Column -->
      <ng-container matColumnDef="lastname">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "model.patient.name" | translate }}
          <app-item-filter
            fieldName="{{ 'model.patient.name' | translate }}"
            [translateFieldKey]="'model.patient.name'"
            propertyName="lastname"
            [dataType]="DATA_TYPE.TEXT"
            [defaultValue]="activeFilters | filterFor : 'lastname'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.lastname }}</mat-cell>
      </ng-container>

      <!-- Firstname Column -->
      <ng-container matColumnDef="firstname">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "model.patient.firstname" | translate }}
          <app-item-filter
            fieldName="{{ 'model.patient.firstname' | translate }}"
            [translateFieldKey]="'model.patient.firstname'"
            propertyName="firstname"
            [dataType]="DATA_TYPE.TEXT"
            [defaultValue]="activeFilters | filterFor : 'firstname'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.firstname }}</mat-cell>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "model.patient.status" | translate }}
          <app-item-filter
            fieldName="{{ 'table.status' | translate }}"
            [translateFieldKey]="'model.patient.status'"
            [translatePrefix]="'prescription.status'"
            propertyName="status"
            [dataType]="DATA_TYPE.CHOICE"
            [defaultValue]="activeFilters | filterFor : 'status'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ "prescription.status." + row.status | translate }}</mat-cell>
      </ng-container>

      <!-- Category Column -->
      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "table.type" | translate }}
          <app-item-filter
            fieldName="{{ 'table.type' | translate }}"
            [translateFieldKey]="'table.type'"
            propertyName="category"
            [dataType]="DATA_TYPE.TEXT"
            [defaultValue]="activeFilters | filterFor : 'category'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.category | translate }}</mat-cell>
      </ng-container>

      <!-- Date request Column -->
      <ng-container matColumnDef="dateRequest">
        <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ "page.deleteRequestList.table.requestDate" | translate }}
          <app-item-filter
            fieldName="{{ 'page.deleteRequestList.table.requestDate' | translate }}"
            [translateFieldKey]="'page.deleteRequestList.table.requestDate'"
            propertyName="firstname"
            [dataType]="DATA_TYPE.DATE"
            [defaultValue]="activeFilters | filterFor : 'dateRequest'"
            (applyFilter)="applyFilter($event)"
          >
          </app-item-filter>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.dateRequest | safeDate : "dd/MM/yyyy HH:mm" }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
    <div class="loading" *ngIf="isLoading">
      <div class="spinner-container">
        <mat-spinner></mat-spinner>
      </div>
      {{ "common.loading" | translate }}
    </div>
    <mat-paginator [length]="prescriptionsCount" [pageSize]="25" [pageSizeOptions]="[25, 50, 100, 250]"> </mat-paginator>
  </mat-card>
</ng-container>
